import { useMemo } from 'react';
import { _ } from '/@/locale';
import { type CornCycle, CornCycleChoices } from '../components/product-card';

const useProductsFilterOptions = (products: any[]) => {
    const technologyOptions = useMemo(() => {
        const technologies: Record<number, string> = {};
        for (const product of products) {
            for (const tech of product.technologies || []) {
                technologies[tech.id] = tech.name;
            }
        }
        return technologies;
    }, [products]);
    const technologyOptionsArray = useMemo(() => Object.entries(technologyOptions), [technologyOptions]);

    const zoneOptions = useMemo(() => {
        const zones: Record<number, string> = {};
        for (const product of products) {
            if (!product.catalogZoneId) continue;
            zones[product.catalogZoneId] = _(product.catalogZone);
        }
        return zones;
    }, [products]);
    const zoneOptionsArray = useMemo(() => Object.entries(zoneOptions), [zoneOptions]);

    const typeOptions = useMemo(() => {
        const types: Record<number, string> = {};
        for (const product of products) {
            if (!product?.type) continue;
            types[product?.type?.id] = _(product?.type);
        }
        return types;
    }, [products]);
    const typeOptionsArray = useMemo(() => Object.entries(typeOptions), [typeOptions]);

    const cropOptions = useMemo(() => {
        const crops: Record<number, string> = {};
        for (const product of products) {
            if (!product?.crops) continue;
            for (const crop of product.crops) {
                crops[crop.id] = _(crop.name);
            }
        }
        return crops;
    }, [products]);
    const cropOptionsArray = useMemo(() => Object.entries(cropOptions), [cropOptions]);

    const cycleOptions = useMemo(() => {
        const cycles: Record<CornCycle, string> = {};
        for (const product of products) {
            if (!product?.cycle) continue;
            cycles[product.cycle as CornCycle] = CornCycleChoices[product?.cycle as CornCycle];
        }
        return cycles;
    }, [products]);
    const cycleOptionsArray = useMemo(() => Object.entries(cycleOptions), [cycleOptions]);

    const positioningOptions = useMemo(() => {
        const positionings: Record<string, string> = {};
        for (const product of products) {
            if (!product?.positioning) continue;
            if (product.positioning.label !== '-') {
                positionings[product.positioning.label] = product.positioning.label;
            }
        }
        return positionings;
    }, [products]);
    const positioningOptionsArray = useMemo(() => Object.entries(positioningOptions), [positioningOptions]);

    return {
        technologyOptions,
        technologyOptionsArray,
        zoneOptions,
        zoneOptionsArray,
        typeOptions,
        typeOptionsArray,
        cropOptions,
        cropOptionsArray,
        cycleOptions,
        cycleOptionsArray,
        positioningOptions,
        positioningOptionsArray,
    };
};

export default useProductsFilterOptions;
